module.exports = __webpack_public_path__ + "img/1inch.1d8b91cf.png";